import { PromotionMailTemplate } from './PromotionMailTemplate';

export { mailTemplateFormFromApi } from './form';
export { LanguageTabs, useLanguageState } from './LanguageTabs';

export default PromotionMailTemplate;
